<div class="container-fluid collectionsPage pt-5">
    <div
        *ngIf="!currentUserAddress"
        class="row justify-content-center pt-5 mt-5 mx-0"
    >
        <div class="col-sm-6">
            <nb-card>
                <nb-card-body>
                    <h2 class="text-center">Please connect your wallet!</h2>
                </nb-card-body>
            </nb-card>
        </div>
    </div>
    <div
        *ngIf="!isWhiteListed && currentAddress"
        class="row justify-content-center pt-5 mt-5 mx-0"
    >
        <div class="col-sm-6">
            <nb-card>
                <nb-card-body>
                    <h2 class="text-center">You are not whitelisted!</h2>
                </nb-card-body>
            </nb-card>
        </div>
    </div>
    <div class="col-md-12" *ngIf="isWhiteListed">
        <div class="row mx-5">
            <div class="col-sm">
                <h3 class="grayH3">Welcome to Beyondi</h3>
            </div>
        </div>
        <div class="row mx-5 d-flex justify-content-between">
            <div class="col-sm-6 col-xl-6">
                <h1 class="h1Mobile">Seed round Contribution</h1>
            </div>
            <div class="col-sm-5 align-self-center mt-5 pt-4">
                <a href="#" target="blank"
                    ><button nbButton status="basic" class="btn float-right">
                        <img
                            class="img-fluid metamaskIcon mr-2"
                            src="../../assets/images/download.png"
                        />
                        Whitepaper
                    </button></a
                >
                <a target="blank" href="#"
                    ><button
                        nbButton
                        status="basic"
                        class="btn mr-5 float-right"
                    >
                        <img
                            class="img-fluid metamaskIcon mr-2"
                            src="../../assets/images/page-flip.png"
                        />
                        Pitch deck
                    </button></a
                >
            </div>
        </div>
        <div class="row mx-5">
            <div class="col-sm-2 col-md col-xl-2 mb-3">
                <h3>Total contributed</h3>
                <hr />
                <br />
                <h5>{{ userContribAmount }} USDT</h5>
            </div>
        </div>
        <div class="row mx-5 pt-4">
            <div class="col-sm-2 col-md col-xl-2 mb-3">
                <h3>Seed Price</h3>
                <hr />
                <br />
                <h5 class="weightedH5">
                    $0.0{{ contributionRules.seedPrice }}
                </h5>
            </div>
            <div class="col-sm-2 col-md col-xl-2">
                <h3>Listing Price</h3>
                <hr />
                <br />
                <h5 class="weightedH5">
                    $0.0{{ contributionRules.listingPrice }}
                </h5>
            </div>
        </div>

        <div class="row pt-5 mx-5">
            <div class="col-sm-2 col-md-4 col-xl-2">
                <h4>Min Contribution</h4>
                <hr />
                <br />
                <h4 class="smallerWeightH4">
                    {{ contributionRules.minContribution }}
                </h4>
            </div>
            <div class="col-sm-2 col-md-8 col-xl-2">
                <h4>Max Contribution</h4>
                <hr />
                <br />
                <h4 class="smallerWeightH4">
                    {{ contributionRules.maxContribution }}
                </h4>
            </div>
            <div class="col-sm-2 col-md-4 col-xl-2">
                <h4>Total Supply</h4>
                <hr />
                <br />
                <h4 class="smallerWeightH4">
                    {{ contributionRules.totalSupply | number }}
                </h4>
            </div>
            <div class="col-sm-2 col-md-4 col-xl-2">
                <h4>Hard Cap</h4>
                <hr />
                <br />
                <h4 class="smallerWeightH4">
                    {{ contributionRules.hardCap | currency }}
                </h4>
            </div>
            <div class="col-sm-2 col-md-4 col-xl-2">
                <h4>Assumed Initial Market Cap</h4>
                <hr />
                <br />
                <h4 class="smallerWeightH4">
                    {{ contributionRules.assumedInitialMarketCap | currency }}
                </h4>
            </div>
        </div>
        <div class="row justify-content-center mt-5">
            <div class="col-md-12">
                <nb-tabset fullWidth>
                    <nb-tab class="tab" tabTitle="Contribute"
                        ><ngx-contribute></ngx-contribute
                    ></nb-tab>
                    <nb-tab class="tab" tabTitle="Recent transactions"
                        ><ngx-recent-transaction></ngx-recent-transaction
                    ></nb-tab>
                </nb-tabset>
            </div>
        </div>

        <div class="col-12">
            <div class="row pt-5 partnersSection mt-5">
                <div class="col-md-3 col-sm-12 text-center firstChild pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/etherum logo 1.png"
                    />
                </div>
                <div class="col-md-3 col-sm-12 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/cronos-logo.png"
                    />
                </div>
                <div class="col-md-3 col-sm-12 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/BSC-lohgo.png"
                    />
                </div>
                <div class="col-md-3 col-sm-12 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/polygon.png"
                    />
                </div>
            </div>
        </div>

        <div class="asSeenOn" *ngIf="false">
            <div class="row text-center py-5">
                <div class="col-sm">
                    <h2>As Seen On</h2>
                </div>
            </div>
            <div class="row d-flex justify-content-between pb-5">
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo1.png"
                    />
                </div>
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo2.png"
                    />
                </div>
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo3.png"
                    />
                </div>
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo4.png"
                    />
                </div>
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo1.png"
                    />
                </div>
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo2.png"
                    />
                </div>
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo3.png"
                    />
                </div>
                <div class="col-sm-3 text-center pb-5">
                    <img
                        class="img-responsive img-fluid"
                        src="../../assets/images/Logo4.png"
                    />
                </div>
            </div>
        </div>
    </div>
    <!-- </div> -->
</div>
